import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import CreatableSelect from 'react-select/creatable';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';
import css from './SelectWithAddButton.module.css'

const SelectWithAddButton = ({ options = [], placeholder, name, isMulti = true, isSearchable = true, isCreateNewFieldDisable=false, label }) => {
  const [selectedItem, setSelectedItem] = useState(null); // Track the selected item locally
  const [error, setError] = useState(null); // Error state

  // Handle the change in selection
  const handleSelectChange = (selectedOption) => {
    setSelectedItem(selectedOption);
    setError(null); // Reset error when new item is selected
  };

  // Handle adding the selected item to the list and clearing the select field
  const handleAddItem = (input) => {
    if (selectedItem) {
      // Add selected item to the form state array
      const newItems = [...(input.value || []), selectedItem];
      const uniqueArr = Array.from(
        new Map(newItems.map(item => [item.label, item])).values()
      );
      input.onChange(uniqueArr); // Update form state with the new array of items
      setSelectedItem(null); // Clear the select field
    } else {
      setError("Please select an item to add."); // Show error if no item is selected
    }
  };

  // Handle removing an item from the form state array
  const handleRemoveItem = (itemToRemove, input) => {
    const updatedItems = input.value.filter(item => item.option != itemToRemove.option);
    input.onChange(updatedItems); // Update form state after removing item
  };

  const isCreateFieldDisabled = isCreateNewFieldDisable ?  {
    isValidNewOption : () => false,
    formatCreateLabel : () => ""
  } : {};

  return (
    <div>
      <Field name={name}>
        {({ input, meta }) => (
          <div>
            {/* Searchable CreatableSelect */}
            <label>{label}</label>
            <div className={css.selectInput}>
              <CreatableSelect
                value={selectedItem}
                onChange={handleSelectChange}
                options={Array.isArray(input.value) ? options.filter((st)=> input.value.findIndex((item) => item.option === st.option) === -1) : options}
                isClearable
                placeholder={placeholder || "Select or create an item"}
                isMulti={isMulti}
                isSearchable={isSearchable}
                {...isCreateFieldDisabled}
              />

              {/* Add Button */}
              <button
                className={css.addButton}
                type="button"
                onClick={() => handleAddItem(input)}
              >
                <ProfileIconCard type="add" />
              </button>
            </div>
            {/* Error Message */}
            {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
            {/* Display Added Items */}
            {input.value && input.value.length > 0 && (
              <div style={{ marginTop: '20px' }}>
                <ul>
                  {input.value.map((item, index) => {
                    const label = ( Array.isArray(options) ? options.find((st)=> item.option == st.option)?.label : null) || item.label || item.option; // Fallback to option if label is not available
                    return (
                    <li key={item.value + index} className={css.addedItems}>
                      <span className={css.itemText}><ProfileIconCard type="orange" />{label}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveItem(item, input)}
                        className={css.removeButton}
                      >
                        <ProfileIconCard type="remove" />
                      </button>
                    </li>
                  )
                  })}
                </ul>
              </div>
            )}

            {/* Optionally, show any validation error */}
            {meta.touched && meta.error && <div style={{ color: 'red' }}>{meta.error}</div>}
          </div>
        )}
      </Field>
    </div>
  );
};

export default SelectWithAddButton;
